import React from "react";
import { createPortal } from "react-dom";

const SuccessModal = ({ message, onClose }) => {
  return createPortal(
    <div className="fixed inset-0 bg-black/45 flex items-center justify-center z-[9999]">
      <div className="bg-white p-6 rounded-xl w-[95%] max-w-xs text-center border-t-[5px] border-green-600 shadow-[0_10px_25px_rgba(0,0,0,0.15)]">
        <h3 className="text-green-600 font-bold mb-2.5">Success</h3>
        <div className="text-lg mb-4 text-[#333]">{message}</div>
        <button
          className="bg-green-600 hover:bg-green-700 text-white border-none px-[18px] py-2.5 rounded-md cursor-pointer font-semibold transition-colors duration-200 font-[inherit]"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>,
    document.body
  );
};

export default SuccessModal;